import { render, staticRenderFns } from "./CostosTab.vue?vue&type=template&id=d0cef906&scoped=true"
import script from "./CostosTab.vue?vue&type=script&lang=js"
export * from "./CostosTab.vue?vue&type=script&lang=js"
import style0 from "./CostosTab.vue?vue&type=style&index=0&id=d0cef906&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0cef906",
  null
  
)

export default component.exports